import React from "react";
import { NewAttributeRow } from "./new-attribute-row";
import { useGroupPairing } from "../hooks/use-group-pairing";
import { isEmpty } from "lodash";
import AttributeRow from "./attribute-row";
import { TaskType } from "shared/taskTypeMap";

export const CodingSizeAttributes = ({
    attributes,
    removeAttribute,
    references,
    readOnlyOverride,
    taskType,
    subGroups,
    columnWidths,
    isReadOnlyAdd,
    isReadOnlyEdit,
    isReadOnlyDelete,
    isCompleted,
    isBrandVerified,
}) => {
    const codingSizeGroups = useGroupPairing(attributes, taskType);

    return (
        <>
            {codingSizeGroups.map((attr, index) => {
                return (
                    <NewAttributeRow
                        columnWidths={columnWidths}
                        key={`attribute_row_${index}`}
                        taskType={taskType}
                        attributesPair={attr}
                        removeAttribute={removeAttribute}
                        readOnlyOverride={readOnlyOverride}
                        references={references}
                        isReadOnlyAdd={isReadOnlyAdd}
                        isReadOnlyEdit={isReadOnlyEdit}
                        isReadOnlyDelete={isReadOnlyDelete}
                        isCompleted={isCompleted}
                        isBrandVerified={isBrandVerified}
                    />
                );
            })}
            {subGroups.map(({ groupLabel, groupName, ...subGroupParams }) => {
                return (
                    <div key={groupName}>
                        <h3>{groupLabel}</h3>
                        {taskType === TaskType.FINAL_QA &&
                            !isEmpty(subGroupParams.attributes) &&
                            subGroupParams.attributes.map((attr) => {
                                return (
                                    <AttributeRow
                                        key={`attributerow_${attr.uuid}`}
                                        attr={attr}
                                        removeAttribute={removeAttribute}
                                        columnWidths={columnWidths}
                                        readOnlyOverride={readOnlyOverride}
                                        references={references}
                                        isReadOnlyAdd={isReadOnlyAdd}
                                        isReadOnlyEdit={isReadOnlyEdit}
                                        isReadOnlyDelete={isReadOnlyDelete}
                                        isCompleted={isCompleted}
                                        isBrandVerified={isBrandVerified}
                                    />
                                );
                            })}
                        {subGroupParams.subGroups.map(({ attributes: innerAttributes, groupName: attrGroup }) => {
                            return (
                                <div
                                    key={`${groupName}_${attrGroup}`}
                                    className="m-t-16"
                                >
                                    <CodingSizeAttributes
                                        columnWidths={columnWidths}
                                        attributes={innerAttributes}
                                        removeAttribute={removeAttribute}
                                        references={references}
                                        readOnlyOverride={readOnlyOverride}
                                        taskType={taskType}
                                        // leave it empty for now
                                        subGroups={[]}
                                        isReadOnlyAdd={isReadOnlyAdd}
                                        isReadOnlyEdit={isReadOnlyEdit}
                                        isReadOnlyDelete={isReadOnlyDelete}
                                        isCompleted={isCompleted}
                                        isBrandVerified={isBrandVerified}
                                    />
                                </div>
                            );
                        })}
                    </div>
                );
            })}
        </>
    );
};
